import Cookies from 'js-cookie';

// Default cookie domain — covers cloud.celerdata.com and any regional
// subdomain. Inlined here because no other consumer needed it.
const SECOND_DOMAIN = 'celerdata.com';

export const getCookie = (name: string): string | undefined => Cookies.get(name);

export const setCookie = (
  name: string,
  value: string,
  expiresDays = 7,
  path = '/',
  domain = SECOND_DOMAIN,
): string | undefined => Cookies.set(name, value, { expires: expiresDays, path, domain });

export const deleteCookie = (name: string, path = '/', domain = SECOND_DOMAIN): void =>
  Cookies.remove(name, { path, domain });
